import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IConfigCountry } from '@lbmx/administration/lib/dtos/updateuser.dto';
import { LoggerService } from '@lbmx/phoenix-lib-core';
import { SpinnerService, ToastrNotificationService } from '@lbmx/phoenix-lib-utils';
import { TranslocoService } from '@ngneat/transloco';
import { Subscription } from 'rxjs/internal/Subscription';
import { IConfigProvince, IDropDown, IMemberLocationForm } from 'src/app/dtos/onboarding/onboarding.dto';
import { OnboardingService } from 'src/app/services/onboarding/onboarding.service';

@Component({
  selector: 'app-member-location',
  templateUrl: './member-location.component.html',
  styleUrls: ['./member-location.component.scss']
})
export class MemberLocationComponent implements OnInit, OnDestroy {

  @Output() public closeLocationDialog = new EventEmitter();
  public subscriptions: Subscription[] = [];
  public countriesDropDown: IDropDown[];
  public provincesDropDown: IDropDown[];
  public provinces: IConfigProvince[];
  public entryId = -1;

  public memberLocationForm: FormGroup = this.formBuilder.group(
    {
      legalcompanyName: ['', [Validators.required]],
      operatingName: ['', [Validators.required]],
      address: ['', [Validators.required]],
      city: ['', [Validators.required]],
      country: ['', [Validators.required]],
      province: ['', [Validators.required]],
      postalCode: ['', [Validators.required]],
      mainPhone: ['', [Validators.required]],
    }
  );

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private loggerService: LoggerService,
    private toastSrv: ToastrNotificationService,
    private spinnerService: SpinnerService,
    private onboardingService: OnboardingService,
    private translocoService: TranslocoService) { }

  public ngOnInit(): void {
    this.getCountries();
    this.getProvinces();
  }

  public getCountries() {
    this.onboardingService.getCountries()
      .pipe()
      .subscribe((val) => {
        this.countriesDropDown = val.map(
          (country: IConfigCountry): IDropDown => {
            return {
              label: country.countryName,
              value: country.countryCode.trim(),
            };
          }
        );
      });
  }

  public getProvinces() {
    this.onboardingService.getProvinces()
      .pipe()
      .subscribe((val) => {
        this.provinces = val;
      });
  }

  public onCountryDropDownSelect() {
    const filteredProv = this.provinces.filter(prov => prov.countryCode === this.memberLocationForm.get('country').value);
    this.provincesDropDown = filteredProv.map((province: IConfigProvince): IDropDown => {
      return {
        label: province.provinceName,
        value: province.provinceCode.trim(),
      };
    });
  }

  public ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
    this.spinnerService.off();
  }

  public prefillForm(location: IMemberLocationForm) {
    this.entryId = location.id;
    this.memberLocationForm.controls.legalcompanyName.setValue(location.legalcompanyName);
    this.memberLocationForm.controls.operatingName.setValue(location.operatingName);
    this.memberLocationForm.controls.address.setValue(location.address);
    this.memberLocationForm.controls.city.setValue(location.city);
    this.memberLocationForm.controls.country.setValue(location.country);
    this.onCountryDropDownSelect();
    this.memberLocationForm.controls.province.setValue(location.province);
    this.memberLocationForm.controls.postalCode.setValue(location.postalCode);
    this.memberLocationForm.controls.mainPhone.setValue(location.mainPhone);
  }

  public save() {
    this.closeLocationDialog.emit({
      id: this.entryId,
      legalcompanyName: this.memberLocationForm.value.legalcompanyName,
      operatingName: this.memberLocationForm.value.operatingName,
      address: this.memberLocationForm.value.address,
      city: this.memberLocationForm.value.city,
      country: this.memberLocationForm.value.country,
      province: this.memberLocationForm.value.province,
      postalCode: this.memberLocationForm.value.postalCode,
      mainPhone: this.memberLocationForm.value.mainPhone,
    });
    this.entryId = -1;
    this.memberLocationForm.reset();
  }

  public handleCancel() {
    this.entryId = -1;
    this.closeLocationDialog.emit(null);
    this.memberLocationForm.reset();
  }
}
